import { createFileRoute, redirect } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';

export const Route = createFileRoute('/settings/property-links')({
  validateSearch: (search) => settingsSearchSchema.parse(search),
  beforeLoad: ({ search }) =>
    redirect({ to: '/settings/tenant', search, replace: true }),
});
